"use strict";
var core_1 = require('@angular/core');
exports.ON_WEB_WORKER = new core_1.OpaqueToken('WebWorker.onWebWorker');
//# sourceMappingURL=api.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/platform-browser/src/web_workers/shared/api.js
 ** module id = 306
 ** module chunks = 2
 **/